import { API_URL } from '../config';

const API_BASE_URL = `${API_URL}/api`;

export const api = {
  async createSession(sessionId) {
    const response = await fetch(`${API_BASE_URL}/sessions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ sessionId })
    });
    return response.json();
  },

  async getSessionData(sessionId) {
    const response = await fetch(`${API_BASE_URL}/sessions/${sessionId}`, {
      credentials: 'include'
    });
    return response.json();
  },

  async saveResponse(sessionId, questionId, responseValue) {
    const response = await fetch(`${API_BASE_URL}/responses`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ sessionId, questionId, responseValue })
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to save response');
    }
    
    return response.json();
  },

  async saveComment(sessionId, questionId, commentText) {
    const response = await fetch(`${API_BASE_URL}/comments`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ sessionId, questionId, commentText })
    });
    return response.json();
  },

  async getAllSessions() {
    const response = await fetch(`${API_BASE_URL}/sessions`, {
      credentials: 'include'
    });
    return response.json();
  },

  async updateSessionCompletion(sessionId, completed) {
    const response = await fetch(`${API_BASE_URL}/sessions/${sessionId}/complete`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ completed })
    });
    return response.json();
  },

  async deleteSession(sessionId) {
    const response = await fetch(`${API_BASE_URL}/sessions/${sessionId}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    return response.json();
  },

  async exportSessionData(sessionId) {
    const response = await fetch(`${API_BASE_URL}/sessions/${sessionId}/export`, {
      credentials: 'include'
    });
    return response.json();
  }
};
